<section class="login_wrapper" *ngIf="!isMobileLayout">
    <div class="container">
        <div class="heading">
            <h1>Welcome to <span>Pillar Blocks </span></h1>
            <p>We make Real Estate Easy for everyone</p>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="login_propLeft">
                    <div class="cashbackimg">
                        <img src="../../../assets/img/login_image.svg" alt="">
                    </div>
                    <div class="loginchoose">
                        <h2>Why you should choose us :</h2>
                        <ul>
                            <li>
                                <p><i class="bi bi-check-square-fill"></i>Post a property for FREE.</p>
                            </li>
                            <li>
                                <p><i class="bi bi-check-square-fill"></i>List Properties till Sale.</p>
                            </li>
                            <li>
                                <p><i class="bi bi-check-square-fill"></i>Enjoy two months of Cash Back on Home Loan
                                    EMIs!</p>
                            </li>
                            <li>
                                <p><i class="bi bi-check-square-fill"></i>Get home loans easily from the banks you
                                    already use.
                                </p>
                            </li>
                            <li>
                                <p><i class="bi bi-check-square-fill"></i>Sale Your Properties 10X Fast with Profiled
                                    Buyers.
                                </p>
                            </li>
                            <li>
                                <p><i class="bi bi-check-square-fill"></i>Avail Property Services ( Packers & Movers,
                                    Rental Agreement, Interior Design & Vaastu )
                                </p>
                            </li>
                            <li>
                                <p><i class="bi bi-check-square-fill"></i>Connect with Verified Buyers & Tenants.
                                </p>
                            </li>
                            <li>
                                <p><i class="bi bi-check-square-fill"></i>Get Unlimited Enquiries on Your Property.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="logincontainer">
                    <!-- Nav tabs -->
                    <!-- <ul class="nav nav-tabs" id="LoginTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button
                                class="nav-link active"
                                data-bs-toggle="tab"
                                data-bs-target="#Login"
                                type="button"
                                role="tab"
                                aria-controls="login"
                                aria-selected="true"
                            >
                            Login
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button
                                class="nav-link"
                                data-bs-toggle="tab"
                                data-bs-target="#SignUp"
                                type="button"
                                role="tab"
                                aria-controls="Sign Up"
                                aria-selected="false"
                            >
                                Sign Up
                            </button>
                        </li>
                    </ul> -->

                    <!-- Tab panes -->

                    <div class="tab-content">

                        <div class="tab-pane active" id="Login" role="tabpanel" aria-labelledby="Login">
                            <div class="loginscreen">
                                <div class="loginheading">
                                    <p></p>
                                    <h2>Forgot Password</h2>
                                </div>
                                <form name="signup" [formGroup]="forgotPwdForm" (ngSubmit)="forgotPassword()"
                                    class="loginform">

                                    <div class="form-group">
                                        <div class="input-group">
                                            <label for="Number" class="form-label">Mobile Number</label>
                                            <ngx-intl-tel-input [cssClass]="'form-control'"
                                                [onlyCountries]="onlyCountries" [enableAutoCountrySelect]="true"
                                                [enablePlaceholder]="false" [searchCountryFlag]="false"
                                                [selectFirstCountry]="false" [maxLength]="15"
                                                [tooltipField]="TooltipLabel.Name" style="width: 100%;"
                                                [phoneValidation]="true" [separateDialCode]="true" id="mobile"
                                                [selectedCountryISO]="selectedISOCountry" name="Mobile"
                                                formControlName="mobile">
                                            </ngx-intl-tel-input>
                                        </div>


                                        <span class="text-danger"
                                            *ngIf="mobile.touched && mobile.errors && mobile.errors.required">
                                            Mobile Number is required.
                                        </span>
                                        <span *ngIf="mobile.valid && mobileExists" style="color:red;" id="mobileexists">
                                            Mobile Already Exists, Please Login
                                        </span>

                                        <span
                                            *ngIf="mobile.touched && !mobile.valid && mobile.errors && mobile.errors.validatePhoneNumber"
                                            style="color:red;" id="mobileNotValid">
                                            Enter Valid Mobile Number.
                                        </span>
                                        <span
                                            *ngIf="!mobileOtpResent && mobileOtpSent && !mobileOtpVerified && !mobileOtpMaxFlag"
                                            style="color:green;" id="mobileotpsuccessmsg1">
                                            OTP Sent to mobile successfully.
                                        </span>
                                        <span *ngIf="mobileOtpResent && !mobileOtpVerified" style="color:green;"
                                            id="mobileotpsuccessmsg1">
                                            OTP Resent to mobile successfully.
                                        </span>
                                        <span *ngIf="mobileOtpMaxFlag" style="color:red;" id="maxOtpError">
                                            Your OTP sending limit is over for today, please try after 24 hours again.
                                        </span>
                                        <span *ngIf="mobileOtpVerified" style="color:green;" id="emailotpsuccessmsg3">
                                            mobile Verified Successfully
                                        </span>
                                        <span *ngIf="mobileOtpError" style="color:red;" id="exists">
                                            Error in sending OTP. Please try again.
                                        </span>
                                        <span class="text-danger" *ngIf="error_message">{{error_message}}</span>
                                        <span class="text-success" *ngIf="success_message">{{success_message}}</span>
                                        <ul class="list-inline sendbtn mt-3">
                                            <li class="list-inline-item">
                                                <button type="button" class="btn btn-primary" *ngIf="!mobileOtpSent"
                                                    [disabled]="mobile.invalid" (click)="sendOtp(mobile.value)">
                                                    SEND OTP</button>
                                                <button type="button" class="btn btn-primary" *ngIf="mobileOtpSent"
                                                    [disabled]="mobile.invalid" (click)="resendOtp(mobile.value)">
                                                    RE-SEND
                                                    OTP</button>
                                            </li>

                                            <!-- <li class="list-inline-item">
                                            <button type="button" class="btn btn-warning resend"
                                                (click)="changeMobile()">Change
                                                Mobile Number</button>
                                        </li> -->
                                        </ul>
                                    </div>
                                    <div class="form-group">
                                        <label for="Name" class="form-label">Enter OTP</label>
                                        <input type="text" class="form-control" placeholder="Enter OTP"
                                            formControlName="mobileOtp">
                                        <span *ngIf="mobileOtp.touched && mobileOtp.errors && mobileOtp.errors.required"
                                            style="color:red;" id="emailOtperror">
                                            OTP is required.
                                        </span>
                                        <span *ngIf="mobileOtpCheck && !mobileOtpVerified" style="color:red;"
                                            id="mobileOtperror2">
                                            OTP is incorrect.
                                        </span>
                                    </div>

                                    <div class="form-group pwd mb-4">
                                        <label for="password" class="form-label">New Password</label>
                                        <div class="input-group">
                                            <input type="{{ hidePassword ? 'password' : 'text' }}" toggle
                                                class="form-control" class="form-control" id="password" name="password"
                                                formControlName="password" placeholder="New Password">
                                            <a href="javascript:void(0)" class="input-group-text"
                                                (click)="togglePassword()">
                                                <i class="bi" [ngClass]="hidePassword ? 'bi-eye' : 'bi-eye-slash'"></i>
                                            </a>
                                        </div>

                                        <span *ngIf="password.touched && password.errors && password.errors.required"
                                            style="color:red;" id="emailOtperror">
                                            New Password is required.
                                        </span>

                                        <!-- previous code -->
                                        <div *ngIf="password?.invalid && (password?.dirty || password?.touched)">
                                            <span class="invalid_msg"
                                                [ngClass]="password.hasError('required') || password.hasError('hasLength')  ? 'text-danger' : 'text-success'">
                                                <i class="material-icons">
                                                    {{ password.hasError('required') || password.hasError('hasLength') ?
                                                    'cancel' : 'check_circle' }}
                                                </i> must be 10 characters!
                                            </span><br>

                                            <span class="invalid_msg"
                                                [ngClass]="password.hasError('required') || password.hasError('hasNumber')  ? 'text-danger' : 'text-success'">
                                                <i class="material-icons">
                                                    {{ password.hasError('required') || password.hasError('hasNumber') ?
                                                    'cancel' : 'check_circle' }}
                                                </i>
                                                must contain at least 1 number!
                                            </span><br>
                                            <span class="invalid_msg"
                                                [ngClass]="password.hasError('required') || password.hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'">
                                                <i class="material-icons">
                                                    {{ password.hasError('required') ||
                                                    password.hasError('hasCapitalCase') ? 'cancel' : 'check_circle' }}
                                                </i>
                                                must contain at least 1 in Capital Case!
                                            </span><br>
                                            <span class="invalid_msg"
                                                [ngClass]="password.hasError('required') || password.hasError('hasSmallCase')  ? 'text-danger' : 'text-success'">
                                                <i class="material-icons">
                                                    {{ password.hasError('required') ||
                                                    password.hasError('hasSmallCase') ? 'cancel' : 'check_circle' }}
                                                </i>
                                                must contain at least 1 Letter in Small Case!
                                            </span><br>
                                            <span class="invalid_msg"
                                                [ngClass]="password.hasError('required') || password.hasError('hasSpecialCharacters') ? 'text-danger' : 'text-success'">
                                                <i class="material-icons">
                                                    {{ password.hasError('required') ||
                                                    password.hasError('hasSpecialCharacters') ? 'cancel' :
                                                    'check_circle' }}
                                                </i>must contain at least 1 Special Character!
                                            </span>
                                        </div>

                                    </div>
                                    <div class="form-group pwd mb-3">
                                        <label for="confirmPwd" class="form-label">Confirm Password</label>
                                        <div class="input-group">
                                            <input type="{{ hideConfirmPassword ? 'password' : 'text' }}" toggle
                                                class="form-control" class="form-control" id="confirmPwd" name="confirmPwd"
                                                formControlName="confirmPwd" placeholder="Confirm Password">
                                            <a href="javascript:void(0)" class="input-group-text"
                                                (click)="toggleConfirmPassword()">
                                                <i class="bi" [ngClass]="hideConfirmPassword ? 'bi-eye' : 'bi-eye-slash'"></i>
                                            </a>
                                        </div>
                                
                                        <span
                                            *ngIf="confirmPwd.touched && confirmPwd.errors && confirmPwd.errors.required"
                                            style="color:red;" id="emailOtperror">
                                            Confirm Password is required.
                                        </span>
                                        <span *ngIf="forgotPwdForm.get('confirmPwd').hasError('misMatch')"
                                            class="text-danger">
                                            Passwords do not match.
                                        </span>
                                    </div>
                                    <button type="submit" class="btn btn-primary" type="submit"
                                        [disabled]="forgotPwdForm.invalid">Submit</button>
                                    <!-- <div class="divder my-4"> -->
                                    <!-- <p> Or </p>
                            </div>
                            <button type="button" class="btn btn-light googlebtn"><i class="bi bi-google"></i> Log in with Google</button>
                            <div class="newuser my-4">
                              <p class="mb-0">Already have an account? <a href="#Login"> LOGIN HERE</a> </p>
                            </div> -->
                                </form>
                                <p style=" color: rgb(56, 56, 201); text-align: center;"><a (click)="backtoLogin()">
                                        < back to Login</a>
                                </p>


                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
<div class="mb-dashboard" *ngIf="isMobileLayout">
    
    <!-- <div class="container">
      <div class="row">
        <div class="col-xl-12 col-lg-12">
            <div class="mb-login">
              <div class="mb-header-image">
                <img src="assets/mobile/img/mb-login-bg.png" alt="">
              </div>
              <div class="mb-header-text">
                <h2 style="text-align: center;color: brown;"> <strong> Forgot Password </strong></h2>
              </div>
              <div class="mb-loginform">
                <div class="form-floating mb-3 mt-3">
                  <input type="text" class="form-control" id="Phone" placeholder="Phone Number" name="Phone">
                </div>
                <div class="form-floating mb-3 mt-3">
                    <input type="text" class="form-control" id="otp" placeholder="Enter OTP" name="otp">
                </div>
                <button class="btn btn-primary">Send Otp</button>
                
                <div class="form-floating mt-3 mb-1">
                  <input type="text" class="form-control" id="pwd" placeholder="New Password" name="newPswd">
                </div>
                <div class="form-floating mt-3 mb-1">
                    <input type="text" class="form-control" id="confirmPwd" placeholder="Confirm Password" name="confirmPswd">
                </div>
                <button class="btn btn-primary mb-loginbtn d-block w-75 m-auto py-3 mt-4">Submit</button>
                <p style=" color: rgb(56, 56, 201); text-align: center;"><a (click)="backtoLogin()">
                    < back to Login</a>
            </p>
              </div>
            </div>
        </div>
    </div>
    </div> -->
    
    <div class="mb-dashboard">
        <section class="mb-login_wrapper mb-5">
          <div class="container">
              <div class="heading pt-4 mb-4">
                  <h1>Welcome to <span> Pillar Blocks </span></h1>
                  <p>We make Real Estate Easy for everyone</p>
              </div>
              <div class="row">
                  <div class="col-lg-12">
                      <div class="logincontainer">
                          <!-- Nav tabs -->
                          <ul class="nav nav-tabs" id="LoginTab" role="tablist">
                              <li class="nav-item" role="presentation">
                                  <button
                                      class="nav-link active"
                                      data-bs-toggle="tab"
                                      data-bs-target="#Login"
                                      type="button"
                                      role="tab"
                                      aria-controls="login"
                                      aria-selected="true"
                                  >
                                  Forgot Password
                                  </button>
                              </li>
                              <!-- <li class="nav-item" role="presentation">
                                  <button
                                      class="nav-link"
                                      data-bs-toggle="tab"
                                      data-bs-target="#SignUp"
                                      type="button"
                                      role="tab"
                                      aria-controls="Sign Up"
                                      aria-selected="false"
                                  >
                                      Sign Up
                                  </button>
                              </li> -->
                          </ul>
                          
                          <!-- Tab panes -->
                          <div class="tab-content">
                              <div class="tab-pane active" id="Login" role="tabpanel" aria-labelledby="Login">
                                  <div class="loginscreen">
                                    <div class="loginheading">
                                      <h2></h2>
                                    </div>
                                    <form name="signup" [formGroup]="forgotPwdForm" (ngSubmit)="forgotPassword()">
                                    <div class="form-group">
                                        <label for="email" class="form-label">Phone Number / Email Id</label>
                                        <div class="form-floating mb-3 mt-3">
                                          <ngx-intl-tel-input [cssClass]="'form-control'" [onlyCountries]="onlyCountries" [enableAutoCountrySelect]="true"
                                            [enablePlaceholder]="false" [searchCountryFlag]="false" [selectFirstCountry]="false" [maxLength]="15"
                                            [tooltipField]="TooltipLabel.Name" style="width: 125%;" [phoneValidation]="true" [separateDialCode]="true"
                                            id="mobile" [selectedCountryISO]="selectedISOCountry" name="loginMobile" formControlName="loginMobile">
                                          </ngx-intl-tel-input>
                                        </div>
                                      </div>
                                      <ul class="list-inline sendbtn mt-3">
                                        <li class="list-inline-item">
                                            <button type="button" class="btn btn-primary" *ngIf="!mobileOtpSent"
                                                [disabled]="mobile.invalid" (click)="sendOtp(mobile.value)">
                                                SEND OTP</button>
                                            <button type="button" class="btn btn-primary" *ngIf="mobileOtpSent"
                                                [disabled]="mobile.invalid" (click)="resendOtp(mobile.value)">
                                                RE-SEND
                                                OTP</button>
                                        </li>
                                    </ul>
                                    <div class="form-group pwd mb-3">

                                    <label for="Name" class="form-label">Enter OTP</label>
                                    <input type="text" class="form-control"
                                        formControlName="mobileOtp">
                                        </div>
                                          <div class="form-group pwd mb-3">
                                            <label for="password" class="form-label">New Password</label>
                                            <div class="input-group">
                                                <input type="{{ hidePassword ? 'password' : 'text' }}" toggle
                                                    class="form-control" class="form-control" id="password" name="password"
                                                    formControlName="password">
                                                <a href="javascript:void(0)" class="input-group-text"
                                                    (click)="togglePassword()">
                                                    <i class="bi" [ngClass]="hidePassword ? 'bi-eye' : 'bi-eye-slash'"></i>
                                                </a>
                                            </div>
                                            <div *ngIf="password?.invalid && (password?.dirty || password?.touched)">
                                                <span class="invalid_msg"
                                                    [ngClass]="password.hasError('required') || password.hasError('hasLength')  ? 'text-danger' : 'text-success'">
                                                    <i class="material-icons">
                                                        {{ password.hasError('required') || password.hasError('hasLength') ?
                                                        'cancel' : 'check_circle' }}
                                                    </i> must be 10 characters!
                                                </span><br>
    
                                                <span class="invalid_msg"
                                                    [ngClass]="password.hasError('required') || password.hasError('hasNumber')  ? 'text-danger' : 'text-success'">
                                                    <i class="material-icons">
                                                        {{ password.hasError('required') || password.hasError('hasNumber') ?
                                                        'cancel' : 'check_circle' }}
                                                    </i>
                                                    must contain at least 1 number!
                                                </span><br>
                                                <span class="invalid_msg"
                                                    [ngClass]="password.hasError('required') || password.hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'">
                                                    <i class="material-icons">
                                                        {{ password.hasError('required') ||
                                                        password.hasError('hasCapitalCase') ? 'cancel' : 'check_circle' }}
                                                    </i>
                                                    must contain at least 1 in Capital Case!
                                                </span><br>
                                                <span class="invalid_msg"
                                                    [ngClass]="password.hasError('required') || password.hasError('hasSmallCase')  ? 'text-danger' : 'text-success'">
                                                    <i class="material-icons">
                                                        {{ password.hasError('required') ||
                                                        password.hasError('hasSmallCase') ? 'cancel' : 'check_circle' }}
                                                    </i>
                                                    must contain at least 1 Letter in Small Case!
                                                </span><br>
                                                <span class="invalid_msg"
                                                    [ngClass]="password.hasError('required') || password.hasError('hasSpecialCharacters') ? 'text-danger' : 'text-success'">
                                                    <i class="material-icons">
                                                        {{ password.hasError('required') ||
                                                        password.hasError('hasSpecialCharacters') ? 'cancel' :
                                                        'check_circle' }}
                                                    </i>must contain at least 1 Special Character!
                                                </span>
                                            </div>
                                          </div>
                                          <div class="form-group pwd mb-3">
                                            <label for="password" class="form-label">Confirm Password</label>
                                            <div class="input-group">
                                                <input type="{{ hideConfirmPassword ? 'password' : 'text' }}" toggle
                                                    class="form-control" class="form-control" id="confirmPwd" name="confirmPwd"
                                                    formControlName="confirmPwd">
                                                <a href="javascript:void(0)" class="input-group-text"
                                                    (click)="toggleConfirmPassword()">
                                                    <i class="bi" [ngClass]="hideConfirmPassword ? 'bi-eye' : 'bi-eye-slash'"></i>
                                                </a>
                                            </div>
                                            
                                          </div>
                                          <div class="remebersec mb-3">
                                            <!-- <div class="checkbox">
                                              <label><input type="checkbox"> Remember me</label>
                                            </div> -->
                                            <!-- <a href="javascript:void(0)" class="d-block mb-3" (click)="forgotPwd()">Forgot password?</a> -->
                                          </div>
                                          <div style="text-align:center;">
                                          <button type="submit" class="btn btn-primary" type="submit"
                                          [disabled]="forgotPwdForm.invalid">Submit</button>
                                          <p style=" color: rgb(56, 56, 201);"><a (click)="backtoLogin()">
                                            < back to Login</a></p>
                                            </div>
                                        <div class="divder my-4">
                                        </div>
                                        
                                      </form>
                                  </div> 
                              </div>
                              <!-- <div class="tab-pane" id="SignUp" role="tabpanel" aria-labelledby="Sign Up" >
                                <div class="loginscreen">
                                  <div class="loginheading">
                                    <p>LET'S GET YOU STARTED</p>
                                    <h2>Create an Account</h2>
                                  </div>
                                    <form action="" class="loginform">
                                        <div class="form-group">
                                            <label for="Name" class="form-label">Your Name</label>
                                            <input type="text" class="form-control" placeholder="Chloe Joe">
                                        </div>
                                        <div class="form-group">
                                          <label for="Number" class="form-label">Mobile Number</label>
                                          <input type="text" class="form-control" placeholder="+91 98********">
                                        </div>
                                        <div class="form-group">
                                          <label for="email" class="form-label">Email Id</label>
                                          <input type="email" class="form-control" placeholder="name@example.com">
                                        </div>
                                        <div class="form-group pwd mb-3">
                                          <label for="password" class="form-label">Password</label>
                                          <div class="input-group">
                                            <input type="password" class="form-control"  placeholder="***************">
                                            <a href="javascript:void(0)" class="input-group-text"><i class="bi bi-eye"></i></a>
                                          </div>
                                        </div>
                                      <button class="btn btn-primary">GET STARTED</button>
                                      <div class="divder my-4">
                                        <p> Or </p>
                                      </div>
                                      <button type="button" class="btn btn-light googlebtn"><i class="ri-google-fill"></i> Log in with Google</button>
                                      <div class="newuser my-4">
                                        <p class="mb-0">Already have an account? <a href="#Login"> LOGIN HERE</a> </p>
                                      </div>
                                    </form>
                                </div> 
                              </div> -->
                          </div>
                          
                      </div>
                      <!-- <div class="mb-loginchoose mt-4 bg-white p-4 rounded-4 shadow-sm">
                        <h2>Why you should choose us :</h2>
                        <ul>
                            <li>
                                <p><i class="ri-checkbox-line"></i> <span>Post a property for FREE.</span></p>
                            </li> 
                            <li>
                                <p><i class="ri-checkbox-line"></i> <span>List Properties till Sale.</span></p>
                            </li>
                            <li>
                                <p><i class="ri-checkbox-line"></i> <span>Enjoy two months of Cash Back on Home Loan EMIs!</span></p>
                            </li> 
                            <li>
                                <p><i class="ri-checkbox-line"></i> <span>Get home loans easily from the banks you already use.</span></p>
                            </li>
                            <li>
                                <p><i class="ri-checkbox-line"></i> <span>Sale Your Properties 10X Fast with Profiled Buyers.</span></p>
                            </li> 
                            <li>
                                <p><i class="ri-checkbox-line"></i> <span>Avail Property Services ( Packers & Movers, Rental Agreement, Interior Design & Vaastu )</span></p>
                            </li>
                            <li>
                                <p><i class="ri-checkbox-line"></i> <span>Connect with Verified Buyers & Tenants.</span></p>
                            </li> 
                            <li>
                                <p><i class="ri-checkbox-line"></i> <span>Get Unlimited Enquiries on Your Property.</span></p>
                            </li>
                        </ul>
                    </div> -->
                  </div>
              </div>
          </div>
        </section>
        <div class="container">
          <div class="row">
            <div class="col-lg-12 pb-4 text-center">
              <small class="copy-right-text">All trademarks, logos and names are properties of their respective owners. Copyright © 2024 - All rights reserved.</small>
            </div>
          </div>
          
        </div>
        
        <!-- <footer>
          <nav class="navbar fixed-bottom bg-secondary">
            <div class="container-fluid">
              <ul class="nav justify-content-center">
                <li class="nav-item">
                  <a class="nav-link text-white" href="#">Terms & Conditions </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link text-white" href="#">Policy</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link text-white" href="#">Home</a>
                </li>
              </ul>
            </div>
          </nav>
        </footer> -->
      </div>
    <!-- <div class="container">
      <div class="row">
        <div class="col-lg-12 pb-4 text-center">
          <small class="copy-right-text">All trademarks, logos and names are properties of their respective owners. Copyright © 2024 - All rights reserved.</small>
        </div>
      </div>
      
    </div> -->
    
    <!-- <footer>
      <nav class="navbar fixed-bottom bg-secondary">
        <div class="container-fluid">
          <ul class="nav justify-content-center">
            <li class="nav-item">
              <a class="nav-link text-white" href="#">Terms & Conditions </a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-white" href="#">Policy</a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-white" href="#">Home</a>
            </li>
          </ul>
        </div>
      </nav>
    </footer> -->
  </div>